import React from 'react';

import { Box } from '@mui/material';

import { CLEARVERIFY_LOGO } from 'src/assets';
import { SxProp } from 'src/types/mui';

interface ClearVerifyLogoProps {
  sx?: SxProp;
  width?: React.CSSProperties['width'];
}

export const ClearVerifyLogo: React.FC<ClearVerifyLogoProps> = ({
  sx = defaultBoxSx,
  width = 191,
}) => (
  <Box sx={sx}>
    <img src={CLEARVERIFY_LOGO} alt="Clear Verify" style={{ display: 'block', width }} />
  </Box>
);

const defaultBoxSx: SxProp = {
  fontSize: 0,
  my: 2,
};
